import inputmask from '../../Global/AsyncModules/inputmask';

export default () => {
    const main = document.querySelector('.from-to');
    if(main) {
        const minVal = main.dataset.min;
        const maxVal = main.dataset.max;

        const inputs = main.querySelectorAll('.input__control');

        inputs.forEach((input) => {
            inputmask(input, {
                alias: 'integer',
                min:minVal,
                max:maxVal,
                placeholder:'',
                allowMinus: false,
                autoGroup: true,
                groupSize: 3,
                groupSeparator: ' ',
                clearMaskOnLostFocus: false
            })
        });
    }
}




// WEBPACK FOOTER //
// ./templates/floor/assets/js/jQueryApplication/esm/fromTo.js